import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'full-layout-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}